import { apiEndpoints } from '@/src/constants/app/urls';
import AxiosClient from '.';

export const baseApiClient = AxiosClient.getInstance(apiEndpoints.base);

const apiKey = process.env.NEXT_PUBLIC_DZAP_API_KEY;
if (apiKey) {
  baseApiClient.defaults.headers.common['x-api-key'] = apiKey;
}
